import axios from 'axios';
export class ApiService {
    constructor(baseUrl, token) {
        this.baseUrl = baseUrl;
        this.token = token;
    }
    async fetchWithToken(input, init) {
        // eslint-disable-next-line no-param-reassign
        if (!init)
            init = {};
        // eslint-disable-next-line no-param-reassign
        if (!init.headers)
            init.headers = {};
        if (this.token) {
            // eslint-disable-next-line no-param-reassign
            init.headers = {
                ...init.headers,
                Authorization: `Bearer ${this.token}`,
            };
        }
        return axios(input, init);
    }
    async get(path, queryParams, responseType = 'json') {
        const url = new URL(this.baseUrl + path);
        if (queryParams) {
            Object.entries(queryParams).forEach(([key, value]) => {
                url.searchParams.append(key, value);
            });
        }
        const init = {
            responseType,
        };
        return this.fetchWithToken(url.toString(), init);
    }
    async post(path, data, customHeaders, onUploadProgress) {
        const url = this.baseUrl + path;
        const init = {
            method: 'POST',
            headers: {
                ...customHeaders,
            },
            data: undefined,
            onUploadProgress,
        };
        if (data instanceof FormData) {
            init.data = data;
        }
        else {
            if (init.headers instanceof Headers) {
                init.headers.append('Content-Type', 'application/json');
            }
            init.data = JSON.stringify(data);
        }
        return this.fetchWithToken(url, init);
    }
    async delete(path, queryParams) {
        const url = new URL(this.baseUrl + path);
        const init = {
            method: 'DELETE',
        };
        if (queryParams) {
            Object.entries(queryParams).forEach(([key, value]) => {
                url.searchParams.append(key, value);
            });
        }
        return this.fetchWithToken(url.toString(), init);
    }
}
//# sourceMappingURL=ApiService.js.map